module.exports = __webpack_public_path__ + "img/Close-icon.26d36df8.svg";